import { useTypedSelector } from 'hooks/use-typed-selector';
import { useMemo, useState } from 'react';
import { fleetRequestConfig } from 'request-config/fleet/fleet.request-config';
import { TableParams } from '../my-vehicles.props';
import { SessionFilter } from 'hooks/use-session-filter';
import { FieldOrderTypes } from './download-exel.types';
import moment from 'moment';
import { useFetch } from 'hooks/use-fetch/use-fetch';
import { useHandleGenerating } from 'hooks/use-handle-generating/use-handle-generating';

export const useDownloadExel = (tableParams: TableParams, sessionFilter: SessionFilter) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const user = useTypedSelector(state => state.app.user);
  const isExportsFlowExist = useTypedSelector(state => state['app'].isExportsFlowExist);
  const { showSnackbar, handleGenerating } = useHandleGenerating();

  const handleShowOptions = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseHistoryList = () => {
    setAnchorEl(null);
  };

  const { fetch: getExelFileInfo } = useFetch({
    loadingKey: 'getExelInfo'
  });

  const handleDownloadFile = async (fieldsOrderType: FieldOrderTypes) => {
    handleCloseHistoryList();

    try {
      const response = await getExelFileInfo({
        requestConfig: fleetRequestConfig.getExcelCompany({
          ContactId: user?.id,
          Pagination: tableParams.pagination,
          Sort: tableParams.sort,
          Search: sessionFilter.filterForServer,
          FieldsOrderType: fieldsOrderType,
          FileName: `Meine-fahrzeuge-${moment().format('DD.MM.yyyy-HH-mm')}.xlsx`,
          DateCreated: moment().format('yyyy.MM.DD'),
          ProductActivated: isExportsFlowExist
        })
      });

      if (response) {
        const { data } = response.data;

        await handleGenerating(
          data.recordId,
          data.isManualMode,
          `Meine-fahrzeuge-${moment().format('DD.MM.yyyy-HH-mm')}.xlsx`
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const options = useMemo(() => {
    return [
      {
        label: 'Standardexport',
        fieldOrderType: FieldOrderTypes.Standart
      },
      {
        label: 'Optimierte Ansicht',
        fieldOrderType: FieldOrderTypes.Accounting
      }
    ];
  }, []);

  return {
    anchorEl,
    options,
    showSnackbar,
    handleShowOptions,
    handleCloseHistoryList,
    handleDownloadFile
  };
};
